export default __webpack_public_path__ + "static/media/empty-star-sq.247f2ecc.png";